import React, { useContext, useMemo } from "react";
import { EntityIdentifier } from "module/entity/types";
import { getEntityIdentifierKey } from "module/entity/helper/getEntityIdentifierKey";
import MaintenanceTaskPartContext from "module/maintenanceTaskPart/context/MaintenanceTaskPartContext";
import MaintenanceTaskContext from "module/maintenanceTask/context/MaintenanceTaskContext";
import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import { MaintenanceTaskPartInterface } from "module/maintenanceTaskPart/types";
import EntityContextProvider from "module/entity/context/entity/EntityContextProvider";

interface Props {
  entityIdentifier: EntityIdentifier;
  children: React.ReactNode;
}

const MaintenanceTaskPartContextProvider: React.FC<Props> = ({
  entityIdentifier,
  children,
}) => {
  const { entity } = useContext(MaintenanceTaskContext);

  const maintenanceTask = entity as MaintenanceTaskInterface;
  const part = useMemo(
    () =>
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      maintenanceTask.relationships.get(entityIdentifier)
        .data as MaintenanceTaskPartInterface,
    [entityIdentifier, maintenanceTask.relationships]
  );
  return (
    <EntityContextProvider
      {...{
        entity: part,
        context: MaintenanceTaskPartContext,
        key: getEntityIdentifierKey(entityIdentifier),
      }}
    >
      {children}
    </EntityContextProvider>
  );
};

export default MaintenanceTaskPartContextProvider;
